import Confirm from '@/components/dialog/Confirm.vue';

let vuetifyInstance = null;
let storeInstance = null;

/**
 * Plugin que agrega this.$confirm() para mostrar un diálogo de confirmación
 * desde cualquier componente sin declararlo en el template.
 *
 * Uso:
 *   try {
 *     await this.$confirm({
 *       title: 'Colgar llamada',
 *       description: '¿Está seguro de que desea terminar la llamada?',
 *       acceptText: 'Sí, colgar',
 *     });
 *     // usuario aceptó
 *   } catch {
 *     // usuario canceló
 *   }
 *
 * @returns {Promise<void>} Resuelve al aceptar, rechaza al cancelar
 */
function install(VueConstructor, options = {}) {
  vuetifyInstance = options.vuetify;
  storeInstance = options.store;

  VueConstructor.prototype.$confirm = function $confirm(opts = {}) {
    const Constructor = VueConstructor.extend(Confirm);
    const container = document.createElement('div');
    document.body.appendChild(container);

    const instance = new Constructor({
      vuetify: vuetifyInstance,
      store: storeInstance,
      propsData: {
        value: true,
        title: opts.title || 'Confirmar',
        description: opts.description || '',
        acceptText: opts.acceptText || 'Aceptar',
        cancelText: opts.cancelText || 'Cancelar',
      },
    });

    instance.$mount(container);

    return new Promise((resolve, reject) => {
      instance.$once('accept', () => {
        instance.$destroy();
        if (container.parentNode) {
          document.body.removeChild(container);
        }
        resolve();
      });
      instance.$once('cancel', () => {
        instance.$destroy();
        if (container.parentNode) {
          document.body.removeChild(container);
        }
        reject(new Error('cancel'));
      });
    });
  };
}

export default { install };
